import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { ALMACEN } from "../Constants/Endpoinst";

const LISTADO_PRODUCTOS_ENDPOINT = ALMACEN.almacen;

export const obtenerTodosLosProductos = async () => {
    const { code, data } = await ApiRequestInterceptorQS(LISTADO_PRODUCTOS_ENDPOINT, "GET");
    return { code, data };
};